// extracted by mini-css-extract-plugin
export var boldText = "_3c-4";
export var checkboxContainer = "_3c-6";
export var closeIcon = "_3c-g";
export var container = "_3c-0";
export var drawer = "_3c-8";
export var drawerContent = "_3c-9";
export var extraSmallText = "_3c-5";
export var fulfillmentGroupTable = "_3c-e";
export var largeText = "_3c-3";
export var loadingSpinnerContainer = "_3c-h";
export var mediumText = "_3c-2";
export var narrow = "_3c-f";
export var notificationLink = "_3c-j";
export var packageCheckIconContainer = "_3c-7";
export var slideoutHeaderContainer = "_3c-a";
export var slideoutModal = "_3c-c";
export var stickyHeaderWrapper = "_3c-b";
export var table = "_3c-i";
export var tableContainer = "_3c-d";
export var tertiaryText = "_3c-1";